import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { expand } from 'uri-template-lite';
import { ClassifierMappingUrl } from './ClassifierMappingUrl';
import { ClassifierMappingDto } from '../types';

const postClassifierMapping = (classifierMapping: ClassifierMappingDto) =>
  apiClient
    .post<ClassifierMappingDto>(
      expand(ClassifierMappingUrl.CLASSIFIER_MAPPING, { id: undefined }),
      classifierMapping
    )
    .then((response) => response.data);

const patchClassifierMapping = (
  id: number,
  classifierMapping: Partial<ClassifierMappingDto>,
  headers?: HttpHeaders
) =>
  apiClient
    .patch<ClassifierMappingDto>(
      expand(ClassifierMappingUrl.CLASSIFIER_MAPPING, { id }),
      classifierMapping,
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

const deleteClassifierMapping = (id: number) =>
  apiClient
    .delete<void>(expand(ClassifierMappingUrl.CLASSIFIER_MAPPING, { id }))
    .then((response) => response.data);

export const useClassifierMappingMutation = createApiMutationHook(
  ['classifierMapping'],
  getMutationFn(
    postClassifierMapping,
    patchClassifierMapping,
    deleteClassifierMapping
  )
);
